import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=0c0c43b9&"
import script from "./FormPage.vue?vue&type=script&lang=js&"
export * from "./FormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports